import Turbolinks from 'turbolinks';
import 'jquery';
import 'popper.js';
import Rails from '@rails/ujs';

// O rails-ujs trata data-method, data-confirm e data-disable-with. O build ESM
// não se inicia sozinho, então a chamada explícita é obrigatória.
Rails.start();
Turbolinks.start();

import '../../images/index.js.erb';
import '../../javascripts/components/index.js.erb';

console.log('Loaded Application');
